import * as React from "react";
import { forwardRef } from "react";
const ExclamationIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M9 1H6v7l1 3h1l1-3zM7.5 15c.82843 0 1.5-.6716 1.5-1.5S8.32843 12 7.5 12 6 12.6716 6 13.5 6.67157 15 7.5 15"
}));
const ForwardRef = forwardRef(ExclamationIcon);
export { ForwardRef as ExclamationIcon };